"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ReviewStep_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterCatalogBuilderScene/SongwriterUpdateRequestSidebar/ReviewStep"));
const EditWriterName_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterCatalogBuilderScene/SongwriterUpdateRequestSidebar/WriterMisspellingForm/EditWriterName"));
const WriterMisspellingForm = (props) => {
    const { onBack, onSubmit, selectedWriterName } = props;
    const [misspelling, setMisspelling] = (0, react_1.useState)({
        correctSpelling: '',
        reasonForCorrection: '',
    });
    const [isReviewing, setIsReviewing] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_1.default.Fragment, null, !isReviewing ? (react_1.default.createElement(EditWriterName_1.default, { onBack: onBack, setIsReviewing: (newIsReviewing) => setIsReviewing(newIsReviewing), misspelling: misspelling, setMisspelling: (newMisspelling) => setMisspelling(newMisspelling) })) : (react_1.default.createElement(ReviewStep_1.default, { header: 'Edit Writer Name', onBack: () => setIsReviewing(false), onSubmit: () => onSubmit(misspelling), selectedWriterName: selectedWriterName },
        react_1.default.createElement("div", null,
            react_1.default.createElement("p", null, "Suggested Correction: "),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, misspelling.correctSpelling))),
        react_1.default.createElement("div", null,
            react_1.default.createElement("p", null, "Reason for Correction "),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, misspelling.reasonForCorrection)))))));
};
exports.default = WriterMisspellingForm;
